import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import orderBy from "lodash/orderBy";
import { GetSupport } from "../../actions/support";
import { DisplayLoading, FinishLoading } from "../../actions/loading";
import { ROUTES } from "../../constants/clientRoutes";
import { FEATURE_FLAGS } from "../../constants/featureFlags";
import { PAGES } from "../../constants/localization";
import { ACTION_DISPLAY_TYPES } from "../../constants/enums";
import i18n from "../../i18n/config";

// Components
import { Link } from "react-router-dom";
import SpinningLoader from "../../components/Common/SpinningLoader";
import Modal from "../../components/Common/Modal";
import ActionLink from "../../components/Common/ActionLink";
import CrewPageAlert from "../../components/Support/CrewPageAlert";
import ConversationList from "../../components/Support/ConversationList";
import Action from "../../components/Common/Action";

export class Conversations extends Component {
  constructor(props) {
    super(props);
    this.showPhones = this.showPhones.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.buildCallSupportModal = this.buildCallSupportModal.bind(this);

    this.state = {
      showPhones: false,
      modalContent: null
    };
  }

  /*TODO: This method was renamed from componentWillMount. 
  Remove once code is verified as working. */
  async componentDidMount() {
    this.props.DisplayLoading();

    if (this.props.conversations.length === 0) {
      await this.props.GetSupport();
    }

    this.props.FinishLoading();
  }

  showPhones() {
    this.setState({
      showPhones: true,
    });
  }

  onCancel() {
    this.setState({
      showPhones: false,
    });
  }

  /**
   * Builds the Call Us modal body.
   * Accepts a list of phone number objects. Has a fallback if needed.
   * @param {*} phoneNumbers array of phone number dtos
   */
  buildCallSupportModal(phoneNumbers) {
    if (!Array.isArray(phoneNumbers) || phoneNumbers.length === 0) {
      const phoneModalContent = (
        <div>
          <p>{PAGES.SUPPORT.FALLBACK_MODAL_TEXT}</p>
        </div>
      );
      return this.createPhoneModal(phoneModalContent);
    }

    const phoneModalContent = (
      <div>
        <div className="support-modal-sub-header">
          {PAGES.SUPPORT.SELECT_CALL}
        </div>
        <div className="flex-col justify-content-center align-items-center">
          {phoneNumbers.map((num) => (
            <ActionLink
              key={num.number}
              classes={"btn btn-primary phone-btn-block spacing-bottom-small"}
              href={`tel:${num.number}`}
            >
              <span className="bold spacing-right-xs">{num.name}</span>{" "}{num.number}
            </ActionLink>
          ))}
        </div>
      </div>
    );

    return this.createPhoneModal(phoneModalContent);
  }

  createPhoneModal = (content) => {
    return (
      <div className="phone-modal">
        <div className="modal-text">
          {content}
        </div>
      </div>
    );
  }

  render() {
    if (this.props.loading) {
      return <SpinningLoader show={true} />;
    }

    const modalContent = this.buildCallSupportModal(this.props.phoneNumbers);

    return (
      <div className="support v3 v2 flow-screen">
        <h1 className="flow-screen__header">Support center</h1>

        {this.props?.featureFlags.includes(FEATURE_FLAGS.ENABLE_CREWLINK_BANNER) &&
          <div className="flex-row justify-content-center">
            <div className="col-xs-12 col-md-8 padding-left-none padding-right-none">
              <CrewPageAlert className="spacing-bottom-none" />
            </div>
          </div>
        }

        <div className="actions-container flex-row justify-content-center">
          <div className="col-xs-12 col-md-8 support-banner bg-blue-800 min-h-88 flex-row justify-content-center align-items-center mobile-direction-column gap-16">
            <Link
              to={ROUTES.SUPPORT_NEW}
              className="btn btn-tertiary"
            >
              <span>{i18n.t("PAGES.SUPPORT.LOGGED_IN.MESSAGE_US")}</span>
            </Link>
            <Action
              title={i18n.t("PAGES.SUPPORT.LOGGED_IN.CALL_US")}
              displayType={ACTION_DISPLAY_TYPES.TERTIARY}
              className="text-white"
              onClick={this.showPhones}
            />
          </div>
        </div>

        <div className="message-history-container flex-row justify-content-center">
          <div className="col-xs-12 col-md-8 padding-left-none padding-right-none">
            <p className="abyss-blue">Message history</p>
            <ConversationList
              conversations={this.props.conversations}
              history={this.props.history}
            />

            <Modal
              title={PAGES.SUPPORT.CALL_US}
              open={this.state.showPhones}
              onClose={this.onCancel}
              disableNativeActions={true}
              content={modalContent}
            />
          </div>
        </div>
      </div>
    );
  }
}

Conversations.propTypes = {
  /** A list of conversations */
  conversations: PropTypes.array.isRequired,
  /** react-router history */
  history: PropTypes.any.isRequired,
  /** List of support phone numbers */
  phoneNumbers: PropTypes.array,
  /** Is data being retrieved */
  loading: PropTypes.bool,
  /** Get the support index action */
  GetSupport: PropTypes.any,
  /** Display spinner action */
  DisplayLoading: PropTypes.any,
  /** Hide spinner action */
  FinishLoading: PropTypes.any,
  /** User feature flags */
  featureFlags: PropTypes.array
};

function mapStateToProps(state) {
  const conversations = orderBy(
    state.support.conversations,
    [
      "hasUnreadMessages",
      (c) => {
        let lastMessage = c.messages[c.messages.length - 1];
        return lastMessage ? new Date(lastMessage.timestamp) : new Date();
      },
    ],
    ["desc", "desc"]
  );

  return {
    conversations,
    phoneNumbers: state.support.phoneNumbers,
    loading: state.spinnersInProgress > 0,
    featureFlags: state.user.featureFlags
  };
}

export default connect(mapStateToProps, {
  GetSupport,
  DisplayLoading,
  FinishLoading,
})(Conversations);
